import * as types from '../mutation-types'
import { API, message } from '../../api'
import { SHARE } from '../../share';

export default {
    namespaced: true,
    state: {
        fromShare: false,
        shareId: '',
        shareData: {},
        shareTitle: '',
        showShareSelectPop: false,
        shareSelectedList: [],
        showShareChangePop: false,
        shareFormData: {},
        showShareSavePop: false,
        shareSaveData: {},
        curDiscussDetailData: {}
    },
    getters: {},
    mutations: {
        [types.OTHER_SHARED_INIT_SELECTE_POP](state) {
            console.log('types.OTHER_SHARED_INIT_SELECTE_POP', state.shareData, state.shareData.list)
            state.showShareSelectPop = true;
            state.shareSelectedList = state.shareData.list;
        },
        [types.OTHER_SHARED_INIT_CHANGE_POP](state) {
            state.showShareChangePop = true;
            state.shareFormData = state.shareData.new;
            state.shareFormData = Object.assign({
                shareTitle: state.shareData.title
            }, state.shareFormData)
        },
        [types.OTHER_SHARED_INIT_SAVE_POP](state, params) {
            state.showShareSavePop = true;
            state.shareSaveData = Object.assign({
                detailId: params.detailId,
                dataId: params.dataId,
                shareTitle: state.shareData.title
            })
        },
        [types.OTHER_SHARED_RESET_DATA](state) {
            state.fromShare = false;
            state.shareId = '';
            state.shareData = {};
            state.shareTitle = '';
            state.shareChanged = false;
            state.shareFormData = {};
            state.shareSeletedListData = [];
            state.shareNewFormData = {};
        },
        [types.OTHER_SHARED_DISCUSS_INIT_SAVE_POP](state, params) {
            state.showShareSavePop = true;
            state.shareSaveData = Object.assign(params);
        },
        [types.OTHER_SHARED_DISCUSS_INIT_CHANGE_POP](state) {
            console.log('types.OTHER_SHARED_DISCUSS_INIT_CHANGE_POP', state.shareData)
            state.showShareChangePop = true;
            state.shareFormData = state.shareData.new;
            state.shareFormData = Object.assign({
                shareTitle: state.shareData.lunpan.f_title
            }, state.shareFormData);
        }
    },
    actions: {
        // 渲染他人分享数据
        showOtherShare({ dispatch, commit, state }, shareData) {
            state.shareId = shareData.code;
            API.getOtherShareData(shareData, function(data){
                console.log("showOtherShare------", data);
                state.fromShare = true;
                state.shareData = Object.assign({}, data);
                state.shareTitle = data.title;
                switch(data.type){
                    case 0:
                    case 1:
                        // 0 点开自己的分享
                        // 1 自己存在当前八字（源相同）
                        dispatch('showMyOwnShare', data)
                        break;             
                    case 2:
                        // 2 自动创建了:仅限于命盘分享（客户端提示保存 save=1  场景 客户端分享的二维码的）
                        break;
                    case 3:
                        // 3 多列表选择，可以另存为 list 的数据为自己的数据，new的数据为另存为调用接口add的数据
                        dispatch('showHaveSameShare', data)
                        break;
                    case 4:
                        // 4 不自动创建（save=0）（数据在new）
                        dispatch('showNewShare', data)
                        break;
                    default:
                        break;
                }
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 10);
            }, function(data) {
                // 获取数据失败的话，跳转到列表页
                AppFate.$toast(message[data.status_code]);
                AppFate.$router.replace('/record');
            })
        },
        // 渲染论盘分享数据
        showDiscussShare({dispatch, commit, state}, shareData) {
            state.shareId = shareData.code;
            API.getOtherShareData(shareData, function(data){
                console.log("showDiscussShare------", data);
                state.shareData = Object.assign({}, data);
                state.shareTitle = data.title;
                switch(data.type) {
                    case 0:
                        state.curDiscussDetailData = data.list[0];
                        dispatch('discuss/initShareLunPan', {
                            detailData: state.curDiscussDetailData,
                            lunpanData: data.lunpan
                        }, { root: true });
                        break;
                    case 1:
                        state.curDiscussDetailData = data.list[0];
                        if(data.cansave == 0) {
                            dispatch('discuss/initShareLunPan', {
                                detailData: state.curDiscussDetailData,
                                lunpanData: data.lunpan
                            }, { root: true });
                        }else {
                            commit(types.OTHER_SHARED_DISCUSS_INIT_SAVE_POP, {
                                hid: state.curDiscussDetailData.id,
                                rid: data.lunpan.rid,
                                shareTitle: data.lunpan.f_title
                            });
                        }
                        break;
                    case 3:
                        state.lunpanData = data.lunpan;
                        commit(types.OTHER_SHARED_INIT_SELECTE_POP);
                        break;
                    case 4:
                        state.lunpanData = data.lunpan;
                        commit(types.OTHER_SHARED_DISCUSS_INIT_CHANGE_POP);
                        break;
                    default:
                        break;
                }
            }, function(data){
                // 获取数据失败的话，跳转到列表页
                AppFate.$router.replace('/record');
            })
        },
        // 他人分享的分享:判断othertype值，重新走一遍渲染流程
        showOtherOtherShare({dispatch, state}, data) {
            // 将othertype值重置到本地的shareType值
            var newData = Object.assign({}, data);
            newData.shareType = data.othertype;
            state.shareData = Object.assign({}, newData);
            console.log('showOtherOtherShare-------', newData, data, state.shareData.shareType);
            switch(newData.type){
                case 0:
                case 1:
                    // 0 点开自己的分享
                    // 1 自己存在当前八字（源相同）
                    dispatch('showMyOwnShare', newData)
                    break;             
                case 2:
                    // 2 自动创建了:仅限于命盘分享（客户端提示保存 save=1  场景 客户端分享的二维码的）
                    break;
                case 3:
                    // 3 多列表选择，可以另存为 list 的数据为自己的数据，new的数据为另存为调用接口add的数据
                    dispatch('showHaveSameShare', newData)
                    break;
                case 4:
                    // 4 不自动创建（save=0）（数据在new）
                    dispatch('showNewShare', newData)
                    break;
                default:
                    break;
            }
        },
        showMyOwnShare({dispatch}, data) {
            // 1:八字分享, 2:反馈分享, 3:批盘分享, 4:反馈对照, 5:他人分享
            switch(data.shareType) {
                case 2:
                    break;
                case 3:
                    dispatch('comment/initSharePiPan', {
                        detailData: data.list[0],
                        pipanData: data.pipan
                    }, { root: true });
                    break;
                case 4:
                    break;
                case 5:
                    dispatch('showOtherOtherShare', data);
                    break;
                default:
                    break;
            }
        },
        showHaveSameShare({dispatch}, data) {
            // 1:八字分享, 2:反馈分享, 3:批盘分享, 4:反馈对照, 5:他人分享
            switch(data.shareType) {
                case 2:
                    break;
                case 3:
                    dispatch('comment/initSharePiPan', {
                        detailData: data.new,
                        pipanData: data.pipan
                    }, { root: true });
                    break;
                case 4:
                    break;
                case 5:
                    dispatch('showOtherOtherShare', data);
                    break;
                default:
                    break;
            }
        },
        showNewShare({dispatch}, data) {
            // 1:八字分享, 2:反馈分享, 3:批盘分享, 4:反馈对照, 5:他人分享
            switch(data.shareType) {
                case 2:
                    break;
                case 3:
                    dispatch('comment/initSharePiPan', {
                        detailData: data.new,
                        pipanData: data.pipan
                    }, { root: true });
                    break;
                case 4:
                    break;
                case 5:
                    dispatch('showOtherOtherShare', data);
                    break;
                default:
                    break;
            }
        },
        // 触发按钮事件
        triggerSaveShare({dispatch, commit, state}) {
            console.log('triggerSaveShare------', state.shareData)
            switch(state.shareData.shareType){
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    // 批盘分享
                    if(state.shareData.type == 1) {
                        dispatch('submitSaveOtherShare', state.shareData.list[0]);
                    }else if(state.shareData.type == 3) {
                        commit(types.OTHER_SHARED_INIT_SELECTE_POP);
                    }else if(state.shareData.type == 4) {
                        dispatch('submitAddPaiPan', state.shareData.new);
                    }
                break;
                case 4:
                    break;
                default:
                    break;
            }
        },
        triggerSaveToNew({commit, state}) {
            console.log('triggerSaveToNew------', state.shareData)
            switch(state.shareData.shareType){
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    // 批盘分享
                    if(state.shareData.type == 3) {
                        commit(types.OTHER_SHARED_INIT_CHANGE_POP);
                    }
                    break;
                case 4:
                    break;
                case 6:
                    // 论盘分享
                    if(state.shareData.type == 3) {
                        commit(types.OTHER_SHARED_DISCUSS_INIT_CHANGE_POP);
                    }
                    break;
                default:
                    break;
            }
        },
        triggerSaveToHave({dispatch, commit, state}, params) {
            console.log('triggerSaveToHave------', state.shareData, params)
            switch(state.shareData.shareType){
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    // 批盘分享
                    if(state.shareData.type == 3) {
                        // 重新渲染批盘数据
                        dispatch('comment/resetData', null, {root: true})
                        dispatch('comment/initSharePiPan', {
                            detailData: params.data,
                            pipanData: state.shareData.pipan
                        }, { root: true });
                        // 显示弹框提交addPipan
                        dispatch('submitSaveOtherShare', params.data);
                        // 执行UI层的回调函数
                        if(params.cb) {
                            setTimeout(() => {
                                params.cb();
                            }, 100);
                        }
                    }
                    break;
                case 4:
                    break;
                default:
                    break;
            }
        },
        updateShareFormData({commit, state}, data) {
            console.log('updateShareFormData-----', state.shareFormData, data.id, data.f_name)
            // 修改分组
            if(data['group_time']){
                if(state.shareFormData.group) {
                    state.shareFormData.group = data.f_name;
                    state.shareFormData.groupId = data.id;
                }else{
                    state.shareFormData = Object.assign({
                        group: data.f_name,
                        groupId: data.id
                    }, state.shareFormData);
                }
            }
        },
        // 触发按钮事件:论盘
        triggerSaveDiscussToHave({commit, state}, data) {
            console.log('triggerSaveDiscussToHave-----', data, state.lunpanData)
            state.curDiscussDetailData = data;
            commit(types.OTHER_SHARED_DISCUSS_INIT_SAVE_POP, {
                hid: data.id,
                rid: state.lunpanData.rid,
                shareTitle: state.lunpanData.f_title
            });
        },
        // 提交修改事件
        submitAddPaiPan({dispatch, commit, state}, formData) {
            console.log('submitAddPaiPan-----', formData)
            API.addPaiPan(formData, function(data){
                console.log('保存命盘成功-----', data)
                AppFate.$store.state.comment.detailInfo = data;
                AppFate.$store.state.detail.personInfo = data;
                dispatch('submitSaveOtherShare', data);
            })
        },
        submitSaveOtherShare({commit, state}, paipanData) {
            console.log('submitSaveOtherShare-----', state.shareData, paipanData.id, state.shareId, state.shareTitle)
            API.saveOtherShareData({
                id: paipanData.id,
                code: state.shareId,
                title: state.shareTitle
            }, function(data){
                console.log('保存他人批盘成功-----', data)
                if(data.isnew == 0) {
                    AppFate.$toast('该批盘已经存在，不再重复保存');
                    AppFate.$store.state.comment.otherSaved = true;
                    AppFate.$store.state.comment.curSubTab = 4;
                    AppFate.$store.state.comment.otherShareTitle = state.shareTitle;
                    // 修改URL
                    AppFate.$router.replace('/comment/othercomment/' + paipanData.id);
                    setTimeout(() => {
                        SHARE.initConfigShare();
                    }, 10);
                }else if(data.isnew == 1) {
                    window._czc.push(["_trackEvent", "批盘模块", "批盘", "保存分享的批盘"]);
                    AppFate.$toast('已自动保存到对应八字下面\n『他人批盘』中');
                    setTimeout(() => {
                        commit(types.OTHER_SHARED_INIT_SAVE_POP, {
                            detailId: paipanData.id,
                            dataId: data.id
                        });
                    }, 10);
                }
            });
        },
        submitEditOtherShare({commit, state}) {
            console.log('submitEditOtherShare----', state.shareData, state.shareSaveData)
            API.editOtherShareData({
                id: state.shareSaveData.dataId,
                title: state.shareSaveData.shareTitle
            }, function(data){
                console.log('修改他人批盘成功-----', data)
            })
        },
        submitSaveToNew({commit, state}, params) {
            var shareTitle = state.shareFormData.shareTitle,
                formData = _.omit(state.shareFormData, ['shareTitle']);
            console.log('submitSaveToNew-------', state.shareFormData, formData, shareTitle, state.shareId)
            // 保存为新的八字和新的批盘
            API.addPaiPan(formData, function(data){
                console.log('保存命盘成功-----', data)
                API.saveOtherShareData({
                    id: data.id,
                    code: state.shareId,
                    title: shareTitle
                }, function(retData){
                    console.log('保存批盘成功-----', retData)
                    state.showShareChangePop = false;
                    if(params.cb) {
                        setTimeout(() => {
                            params.cb(data);
                        }, 100);
                    }
                })
            })
        },
        // 提交修改事件:论盘
        submitEditDiscussShare({dispatch, state}, params) {
            console.log('submitEditDiscussShare====', state.shareSaveData)
            state.showShareSavePop = false;
            API.addLunPan({
                hid: state.shareSaveData.hid,
                rid: state.shareSaveData.rid,
                f_title: state.shareSaveData.shareTitle
            }, function(data) {
                console.log('保存论盘成功::::::', data)
                window._czc.push(["_trackEvent", "论盘模块", "论盘", "保存分享的论盘"]);
                
                // 更新列表数据的论盘状态
                dispatch('record/updateRecordListLunpanStatus', state.shareSaveData.hid, {root: true})
                dispatch('detail/updateDetailLunpanStatus', null, {root: true});

                state.shareData.cansave = 0;
                state.lunpanData = data;
                // 渲染页面
                dispatch('discuss/initShareLunPan', {
                    detailData: state.curDiscussDetailData,
                    lunpanData: data
                }, { root: true });
                // 执行UI回调函数
                setTimeout(() => {
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }, 100);
            })
        },
        submitSaveDiscussToNew({dispatch, state}, params) {
            console.log('submitSaveDiscussToNew-----', params, state.shareFormData);
            var shareTitle = state.shareFormData.shareTitle,
                formData = _.omit(state.shareFormData, ['shareTitle']);
            state.showShareChangePop = false;
            API.addPaiPan(formData, function(data){
                console.log('保存命盘成功-----', data)
                API.addLunPan({
                    hid: data.id,
                    rid: state.lunpanData.rid,
                    f_title: shareTitle
                }, function(retData){
                    console.log('保存论盘成功-----', retData)
                    // 更新列表数据的论盘状态
                    dispatch('record/updateRecordListLunpanStatus', data.id, {root: true})
                    dispatch('detail/updateDetailLunpanStatus', null, {root: true});

                    state.shareData.cansave = 0;
                    state.lunpanData = data;
                    dispatch('discuss/initShareLunPan', {
                        detailData: data,
                        lunpanData: retData
                    }, { root: true });

                    setTimeout(() => {
                        if(params && params.cb && typeof(params.cb) == 'function') {
                            params.cb(data);
                        }
                    }, 100);
                })
            })

        },
        // 重置数据
        resetData({ commit }) {
            commit(types.OTHER_SHARED_RESET_DATA)
        }
    }
}